exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".build-info[data-v-9699a66c]{padding:20px}.build-info pre[data-v-9699a66c]{overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"1","vue":true,"id":"data-v-9699a66c","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/apps/info/spv.vue
// module id = cp2A
// module chunks = 0